module.exports = __webpack_public_path__ + "media/images/icons/filled/delete-85df56e82ebc212f487861b9307ee832.svg";